import VueI18n from 'vue-i18n'
import messages from './messages'
import locale from './locale'

export default () => {
    return new VueI18n({
        locale: locale.locale,
        messages,
    })
}